import { lazy, memo } from "react";
import { isMobile } from "react-device-detect";
import "react-loading-skeleton/dist/skeleton.css";
//import ApiAuth from "../../../core/api/api.auth";


const MobileFooter = lazy(() => import("./MobileFooter"));
const DesktopFooter = lazy(() => import("./DesktopFooter"));

function FooterNav() {

  return (
    <footer>
      {/* ***** mobile ******************************************* */}
      {isMobile ? (
        <MobileFooter />
      ) : (
        // ***** desktop *******************************************
        <DesktopFooter />
      )}
    </footer>
  );
}
export default memo(FooterNav);

